// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'getty-events',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'GETTY IMAGES',
  heroHeadingTwo: 'EVENT PLATFORM',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle'],
    },
    {
      title: 'BRAND',
      items: ['Getty Images'],
    },
    {
      title: 'PLATFORM',
      items: ['Google Cloud Platform', 'Google Cardboard', 'Getty API'],
    },
  ],
  heading: 'EXPERIENTIAL ENGAGEMENT PLATFORM USING VR TO PROMOTE GETTY IMAGES CONTENT',
  challengeImg: 'challenge.jpg',
  challenge: ['To enable Getty Images to deliver a variety of customer experiences at sales and marketing events.'],
  solutionImg: 'solution.jpg',
  solution: ['We created a platform for the global events team, allowing them to deliver pop-up experiences that can be customised and reused at multiple Getty Images events around the world.',
    'The first experience showcased Getty Images latest 360° photography collections using Google Cardboard, as part of their ‘In search of’ campaign, launched at the Cannes Lions International Festival of Creativity.',
    'The Web VR application was complemented by a number of components, with a Raspberry Pi acting as  server and Wi-Fi hotspot, in order to deliver a local event infrastructure and to stream the customer experience and other Getty Images marketing material to TV screens.',
    'Additional customer modules were then developed including two large format touch screen experiences that allowed users to browse content by geography and timeline, showcasing Getty Images’ archive of Beatles photos and videos.'],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: '',
      content: ['THE PLATFORM DELIVERED A 300% UPLIFT IN CUSTOMER SIGN-UPS.'],
    },
    {
      img: 'callout_2.jpg',
      title: '',
      content: ['EXPERIENCES EXTENDED TO TOUCHSCREEN PROJECTION TECHNOLOGY.'],
    },
    {
      img: 'callout_3.jpg',
      title: '',
      content: ['ADDITION OF WORLD MAP AND TIMELINE COMPONENTS HAS INCREASED FLEXIBILITY.'],
    },
  ],
  nextCaseStudy: 'fabricius',
};

export default casestudyData;
